var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.$store.state.fbInitialized
      ? _c("div", [
          _vm.errors.length > 0
            ? _c("div", { staticClass: "error py-2 mb-2" }, [
                _c("b", [
                  _vm._v("An error occured while connecting with Facebook!"),
                ]),
              ])
            : _vm._e(),
          _vm.$store.state.loginStatus
            ? _c("div", { staticClass: "profile-info" }, [
                _c("p", {
                  staticClass: "login-confirmation",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("login_page.login_context_confirmation")
                    ),
                  },
                }),
                _vm.$store.state.profile.picture &&
                _vm.$store.state.profile.picture.data
                  ? _c("img", {
                      staticClass: "float-left mr-3 avarta",
                      attrs: { src: _vm.$store.state.profile.picture.data.url },
                    })
                  : _vm._e(),
                _c("p", { staticClass: "name-email" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$store.state.profile.name) +
                      "\n        "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$store.state.profile.email) +
                      "\n      "
                  ),
                ]),
              ])
            : _c("div", [
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("login_page.login_prompt")),
                  },
                }),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("login_page.login_context_reminder", {
                        extra_reqs: _vm.$t(
                          "global." +
                            _vm.translationSection +
                            ".app_permission_requirements"
                        ),
                      })
                    ),
                  },
                }),
              ]),
        ])
      : _vm._e(),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.$store.state.fbInitialized,
            expression: "$store.state.fbInitialized",
          },
        ],
        staticClass: "actionBar",
      },
      [
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loadingLogin,
              expression: "!loadingLogin",
            },
          ],
          staticClass: "fb-login-button",
          attrs: {
            "data-max-rows": "1",
            "data-size": "large",
            "data-width": "250",
            "data-button-type": "continue_with",
            "data-scope": _vm.scope,
            "data-show-faces": "false",
            "data-auto-logout-link": "true",
            "data-use-continue-as": "false",
          },
        }),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loadingLogin,
                expression: "loadingLogin",
              },
            ],
            attrs: { id: "loadingLogin" },
          },
          [_vm._v(_vm._s(_vm.$t("global.wait")))]
        ),
      ]
    ),
    !_vm.$store.state.fbInitialized ? _c("div", [_vm._m(0)]) : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "progress" }, [
      _c("div", {
        staticClass: "progress-bar progress-bar-striped progress-bar-animated",
        staticStyle: { width: "75%" },
        attrs: {
          role: "progressbar",
          "aria-valuenow": "75",
          "aria-valuemin": "0",
          "aria-valuemax": "100",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }